import Marquee from "react-fast-marquee";

// Placeholder brand names rendered as elegant wordmarks
const BRANDS = [
"Cavinkare","Meera shampoo","goibibo","Vanaura Organics","Samudhrika Lakshana","Kaleesuwari","Sanchu Animal Hospital","CK Bakery","Elixify Skin ClinicCredait",
"Spinz","Delta","Divine Foods","Cavin's","Ghats Honey","Go Paisa","Herbodaya","Indica","Inventaa Lighting","Iplanet","Karthika","Limelite saloon & Spa",
"Green Trends","Sree surya pattu centre","Pothys","Precisalign","Greens Fittness Studio","GSquare","NXT Wave","Technosport","Cashify",
];

export default function BrandMarquee({ direction = "left", speed = 38, label }) {
  return (
    <div data-testid="brand-marquee" className="w-full">
      {label && <div className="label-eyebrow text-center mb-8">{label}</div>}
      <div className="marquee-wrapper">
        <Marquee direction={direction} speed={speed} gradient={false} pauseOnHover>
          {BRANDS.concat(BRANDS).map((brand, i) => (
            <div
              key={`${brand}-${i}`}
              className="brand-tile mx-10 md:mx-14 py-4 font-display text-3xl md:text-4xl font-medium tracking-tight text-[#F3E8E0] whitespace-nowrap"
            >
              {brand}
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
